<template>
  <div>
    <v-simple-table height="400" fixed-header class="exchange-table" id="style-2">
      <template v-slot:default>
        <thead>
          <tr>
            <th style="min-width: 200px; max-width: 200px">Người thực hiện</th>
            <th style="min-width: 200px; max-width: 200px">Thời gian</th>
            <th style="min-width: 600px; max-width: 600px">Mô tả</th>
          </tr>
        </thead>
        <tbody v-if="data.length > 0">
          <tr v-for="(item, index) in data" :key="'exchange' + index">
            <td>{{item.creator.fullName}}</td>
            <td>{{formatDateCus(item.createdAt, 'YYYY-MM-DD HH:mm')}}</td>
            <td>{{item.description}}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="3" class="text-center red--text py-6">Không có dữ liệu</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import ContactRepository from '@/services/ContactRepository';

export default {
  name: 'ExchangeTab',
  data() {
    return {
      data: [],
    };
  },
  props: {
    contactData: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.getListExchange();
  },
  methods: {
    async getListExchange() {
      const result = await ContactRepository.getContactNotes(this.contactData.id);
      if (result.message === 'Success') {
        this.data = result.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.exchange-table {
  table {
    thead {
      tr {
        th {
          background: #EFEFEF !important;
        }
      }
    }
  }
}
</style>
